// extracted by mini-css-extract-plugin
export default {"logoImage":"LogoImage_logoImage__t6XFK","logoImage_isMarkOnly":"LogoImage_logoImage_isMarkOnly__GzCV0"};